import * as Sentry from "@sentry/react";
import { sentryBeforeSend } from "./sentryBeforeSend";

interface SentryEnvConfig {
  env: string;
  isProd: boolean;
}

/**
 * Builds the options object passed to Sentry.init(). Extracted from index.tsx
 * so this project's CRITICAL "never trace student data" constraint (see
 * CLAUDE.md) is directly testable rather than only exercised at app boot.
 */
export function buildSentryInitOptions(config: SentryEnvConfig): Sentry.BrowserOptions {
  return {
    dsn: process.env.REACT_APP_SENTRY_DSN,
    enabled: config.isProd,
    environment: config.env,
    integrations: [
      // traceFetch/traceXHR: separate from breadcrumbsIntegration's fetch/xhr flags below —
      // browserTracingIntegration's own span capture also records request URLs (student IDs
      // in API URL paths) unless disabled here.
      Sentry.browserTracingIntegration({ traceFetch: false, traceXHR: false }),
      // fetch/xhr: student IDs in API URL paths; dom: student names in click targets;
      // history: SPA routes; console: 401 interceptors log Axios errors with config.url.
      Sentry.breadcrumbsIntegration({ fetch: false, xhr: false, history: false, dom: false, console: false }),
    ],
    tracesSampleRate: config.isProd ? 0.1 : 0,
    sendDefaultPii: false,
    // Backstop: explicit addBreadcrumb() calls bypass the integration channel flags above.
    beforeBreadcrumb: () => null,
    beforeSend: sentryBeforeSend,
  };
}
